import { useAuth } from '@hooks/use-auth';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const CHANGE_PASSWORD_PATH = '/change-password';

export default function ProtectedRoute(): React.JSX.Element {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  /**
   * A password an admin reset is temporary, so nothing else in the admin opens
   * until its holder has replaced it. Enforced here rather than only after login,
   * so a stored session or a typed URL cannot walk around it.
   */
  if (user?.mustChangePassword && location.pathname !== CHANGE_PASSWORD_PATH) {
    return <Navigate to={CHANGE_PASSWORD_PATH} replace />;
  }

  return <Outlet />;
}
